var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"search-results"},[_c('div',_vm._g({staticClass:"container"},_vm.listeners.touchmove ? { touchmove: _vm.listeners.touchmove } : null),[_c('div',{staticClass:"content"},[_vm._t("content")],2)]),_vm._v(" "),_vm._t("view-results-button")],2)}
var staticRenderFns = []

export { render, staticRenderFns }